import type { App } from "vue";

import { createMongoAbility } from "@casl/ability";
import { abilitiesPlugin } from "@casl/vue";
import type { Rule } from "./ability";

export default function (app: App) {
  const userAbilityRules = JSON.parse(
    localStorage.getItem("userAbilityRules") ?? "[]",
  ) as Rule[];
  const initialAbility = createMongoAbility(userAbilityRules ?? []);

  app.use(abilitiesPlugin, initialAbility, {
    useGlobalProperties: true,
  });
}
